import { render } from "./ProductDetails.vue?vue&type=template&id=75c62a26&scoped=true&ts=true"
import script from "./ProductDetails.vue?vue&type=script&lang=ts"
export * from "./ProductDetails.vue?vue&type=script&lang=ts"

import "./ProductDetails.vue?vue&type=style&index=0&id=75c62a26&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c62a26"]])

export default __exports__